import React from 'react'
import 'rc-slider/assets/index.css'
import Slider from 'rc-slider'

class RcSlider extends React.Component {
  constructor(props) {
    super(props);

    this.state = { value: this.props.value };
  }

  handleChange = (value) => {
    this.setState({ value });
    if(this.props.onChange) {
      this.props.onChange(value);
    }
  };


  render() {
    const {
      label,
      min,
      max,
      unit
    } = this.props;

    const { value } = this.state;

    return (
      <React.Fragment>
        <p className="sfpro-regular mb-20">
          {label}:
          <span>{value}</span> {unit}
        </p>

        <Slider
          value={value}
          min={min}
          max={max}
          onChange={this.handleChange}
        />
      </React.Fragment>
    )
  }
}

export default RcSlider
